var map = {
	"./lobby_bonuses.png": "b841",
	"./lobby_welcome.png": "ba90",
	"./machines/busy/busy_1.png": "fca0",
	"./machines/busy/busy_10.png": "bfbc",
	"./machines/busy/busy_11.png": "4e5e",
	"./machines/busy/busy_12.png": "792a",
	"./machines/busy/busy_2.png": "7bfd",
	"./machines/busy/busy_3.png": "3c34",
	"./machines/busy/busy_4.png": "3237",
	"./machines/busy/busy_5.png": "dc01",
	"./machines/busy/busy_6.png": "0867",
	"./machines/busy/busy_7.png": "b186",
	"./machines/busy/busy_8.png": "92f9",
	"./machines/busy/busy_9.png": "15a9",
	"./machines/free/basic/free_1.png": "28e3",
	"./machines/free/basic/free_10.png": "c131",
	"./machines/free/basic/free_11.png": "9bea",
	"./machines/free/basic/free_12.png": "1c30",
	"./machines/free/basic/free_2.png": "004d",
	"./machines/free/basic/free_3.png": "d0e5",
	"./machines/free/basic/free_4.png": "48ad",
	"./machines/free/basic/free_5.png": "cacc",
	"./machines/free/basic/free_6.png": "4838",
	"./machines/free/basic/free_7.png": "d8ad",
	"./machines/free/basic/free_8.png": "d3b6",
	"./machines/free/basic/free_9.png": "b955",
	"./machines/free/luxe/free_25.png": "ae2e",
	"./machines/free/luxe/free_26.png": "d077",
	"./machines/free/luxe/free_27.png": "f3fa",
	"./machines/free/luxe/free_28.png": "445b",
	"./machines/free/luxe/free_29.png": "4805",
	"./machines/free/luxe/free_30.png": "0637",
	"./machines/free/luxe/free_31.png": "6cc5",
	"./machines/free/luxe/free_32.png": "7850",
	"./machines/free/luxe/free_33.png": "e3ec",
	"./machines/free/luxe/free_34.png": "bded",
	"./machines/free/luxe/free_35.png": "e355",
	"./machines/free/luxe/free_36.png": "628e",
	"./machines/free/middle/free_13.png": "8446",
	"./machines/free/middle/free_14.png": "2e34",
	"./machines/free/middle/free_15.png": "2343",
	"./machines/free/middle/free_16.png": "8f82",
	"./machines/free/middle/free_17.png": "0d18",
	"./machines/free/middle/free_18.png": "4ffc",
	"./machines/free/middle/free_19.png": "e3e5",
	"./machines/free/middle/free_20.png": "7be5",
	"./machines/free/middle/free_21.png": "9298",
	"./machines/free/middle/free_22.png": "d4bc8",
	"./machines/free/middle/free_23.png": "c5d7",
	"./machines/free/middle/free_24.png": "acce",
	"./machines_mobile/busy/busy_1.png": "1b38",
	"./machines_mobile/busy/busy_10.png": "287c",
	"./machines_mobile/busy/busy_11.png": "b0ac",
	"./machines_mobile/busy/busy_12.png": "0770",
	"./machines_mobile/busy/busy_2.png": "4423",
	"./machines_mobile/busy/busy_3.png": "34e8",
	"./machines_mobile/busy/busy_4.png": "c9df",
	"./machines_mobile/busy/busy_5.png": "4b90",
	"./machines_mobile/busy/busy_6.png": "6814",
	"./machines_mobile/busy/busy_7.png": "7092",
	"./machines_mobile/busy/busy_8.png": "3deb",
	"./machines_mobile/busy/busy_9.png": "81be",
	"./machines_mobile/free/basic/free_1.png": "4375",
	"./machines_mobile/free/basic/free_10.png": "1549",
	"./machines_mobile/free/basic/free_11.png": "7104",
	"./machines_mobile/free/basic/free_12.png": "7ecd",
	"./machines_mobile/free/basic/free_2.png": "cc64",
	"./machines_mobile/free/basic/free_3.png": "6410",
	"./machines_mobile/free/basic/free_4.png": "42ce",
	"./machines_mobile/free/basic/free_5.png": "81ce",
	"./machines_mobile/free/basic/free_6.png": "3296",
	"./machines_mobile/free/basic/free_7.png": "e05b",
	"./machines_mobile/free/basic/free_8.png": "e554",
	"./machines_mobile/free/basic/free_9.png": "9921",
	"./machines_mobile/free/luxe/free_25.png": "a368",
	"./machines_mobile/free/luxe/free_26.png": "2c0e",
	"./machines_mobile/free/luxe/free_27.png": "b8ac",
	"./machines_mobile/free/luxe/free_28.png": "010f",
	"./machines_mobile/free/luxe/free_29.png": "6ddb",
	"./machines_mobile/free/luxe/free_30.png": "8b81",
	"./machines_mobile/free/luxe/free_31.png": "8fc5",
	"./machines_mobile/free/luxe/free_32.png": "2a9f",
	"./machines_mobile/free/luxe/free_33.png": "c32e",
	"./machines_mobile/free/luxe/free_34.png": "c3a5",
	"./machines_mobile/free/luxe/free_35.png": "7345",
	"./machines_mobile/free/luxe/free_36.png": "7cbf",
	"./machines_mobile/free/middle/free_13.png": "cbdc",
	"./machines_mobile/free/middle/free_14.png": "1793",
	"./machines_mobile/free/middle/free_15.png": "e963",
	"./machines_mobile/free/middle/free_16.png": "21f3",
	"./machines_mobile/free/middle/free_17.png": "f81f",
	"./machines_mobile/free/middle/free_18.png": "8cd7",
	"./machines_mobile/free/middle/free_19.png": "d800",
	"./machines_mobile/free/middle/free_20.png": "5045",
	"./machines_mobile/free/middle/free_21.png": "a2f4",
	"./machines_mobile/free/middle/free_22.png": "97f7",
	"./machines_mobile/free/middle/free_23.png": "ee80",
	"./machines_mobile/free/middle/free_24.png": "c86a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b70cf0";